(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderDialogController', SkipperLevelHolderDialogController);

    SkipperLevelHolderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SkipperLevelHolder'];

    function SkipperLevelHolderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SkipperLevelHolder) {
        var vm = this;

        vm.skipperLevelHolder = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.skipperLevelHolder.id !== null) {
                SkipperLevelHolder.update(vm.skipperLevelHolder, onSaveSuccess, onSaveError);
            } else {
                SkipperLevelHolder.save(vm.skipperLevelHolder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:skipperLevelHolderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
